import React, {ReactNode} from 'react';

interface WinnerBannerProps {
    isOpponent: boolean;
    playerSocialID: string;
    avatar: string;
    prize: string;
    prizePoints: number;
}

const WinnerBanner: React.FC<WinnerBannerProps> = ({isOpponent, playerSocialID, avatar, prizePoints, prize}) => {
    return (
        <div
            style={{
                fontFamily: "Troika !important",
                width: 'calc(100% - 28px)'
            }}
            className=" troika absolute fade-in-pop top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-lg  z-[999]">
            <img src={isOpponent ? "./bg-lost.svg" : "./bg-won.svg"}
                 className={"absolute -z-[1] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[120px] w-full object-contain"}/>
            <div className="-rotate-4">
                <div className="flex justify-center items-center gap-4 w-full">
                    <img
                        src={avatar}
                        alt="Avatar"
                        className="w-[40px] h-[40px] rounded-full"
                    />

                    {isOpponent ? (
                        <div className="flex flex-col justify-center items-start my-4">
                            <span className="text-purple-700 font-bold text-lg">{playerSocialID}</span>
                            <span
                                className="text-purple-700 font-bold text-xl md:text-2xl">{prize}</span>
                        </div>
                    ) : (
                        <div className="flex flex-col justify-center items-start my-4">
                            <span className="text-purple-700 font-bold text-lg">YOU GOT</span>
                            <span className="text-purple-700 font-bold text-xl md:text-2xl">{prize}</span>
                        </div>
                    )}

                    <div className="text-purple-700 font-bold text-2xl">+{prizePoints}</div>
                </div>
            </div>

        </div>
    );
};

export default WinnerBanner;
